import apiClient, { extractData } from "./client";

/**
 * Vendor-only Brand Admin API client. Every endpoint here is only
 * reachable when the server has BRAND_ADMIN_ENABLED=true (see
 * backend/src/modules/brand-admin) — on a normal client deployment
 * these calls simply 403. The screen calling this client is itself
 * gated by isBrandAdminUiEnabled() (src/config/brandAdminAccess.js) so
 * it never renders on a client build in the first place.
 */

export async function listBrands() {
  const response = await apiClient.get("/brand-admin/brands");
  return extractData(response);
}

export async function getBrand(id) {
  const response = await apiClient.get(`/brand-admin/brands/${id}`);
  return extractData(response);
}

export async function createBrand(dto) {
  const response = await apiClient.post("/brand-admin/brands", dto);
  return extractData(response);
}

export async function updateBrand(id, dto) {
  const response = await apiClient.patch(`/brand-admin/brands/${id}`, dto);
  return extractData(response);
}

export async function deleteBrand(id) {
  const response = await apiClient.delete(`/brand-admin/brands/${id}`);
  return extractData(response);
}

export async function uploadBrandAsset(id, assetType, file) {
  const formData = new FormData();
  formData.append("file", file);

  const response = await apiClient.post(
    `/brand-admin/brands/${id}/assets/${assetType}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } },
  );
  return extractData(response);
}

export async function getManifestPreview(id) {
  const response = await apiClient.get(
    `/brand-admin/brands/${id}/manifest-preview`,
  );
  return extractData(response);
}
